import { SVGProps } from 'react'

const ExternalArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M12.0208 3.85103L4.94975 3.85103M12.0208 3.85103L12.0208 10.9221M12.0208 3.85103L3.53553 12.3363"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default ExternalArrowIcon
